import React from 'react';
import { Link } from 'react-router-dom';
import bg from '../../images/background/pattern-4.png';
import rv1 from '../../images/background/price-1.png';
import rv2 from '../../images/background/price-1-1.png';
import mv1 from '../../images/background/price-2.png';
import mv2 from '../../images/background/price-2-1.png';
import lv1 from '../../images/background/price-3.png';
import lv2 from '../../images/background/price-3-1.png';

// ✅ Import your hover background images
import hover1 from '../../images/background/hover-1.jpg';
import hover2 from '../../images/background/hover-2.jpg';
import hover3 from '../../images/background/hover-3.jpg';

const pricing = [
    {
        li1: 'Mindful Workshops',
        li2: 'Reflect, Realign and Rediscover purpose',
        li3: 'Nature Immersion',
        li4: 'Breath, Wander and Reconnect',
        li5: 'Community Circles',
        li6: 'Honest Talks, Shared Growth Journeys',
        title: 'The Reset Project',
        price: 'Z_Meghalaya',
        shape: rv1,
        shape2: rv2,
        hoverBg: hover1,
        day: 'October 18, 2025',
        link: 'https://thelushminds.com/event-details/z_meghalaya',
        buttonText: 'Know More',
        greenPrice: true,
        greenButton: true,
    },
    {
        li1: 'Interactive Panels',
        li2: 'Ideas that inspire collaboration',
        li3: 'Collaboration Labs',
        li4: 'Create, co-build, and innovate together',
        li5: 'Network Evenings',
        li6: 'Conversations over food and fire',
        title: 'The Connect Tour',
        price: 'Z_Arunachal',
        active: 'active',
        shape: mv1,
        shape2: mv2,
        hoverBg: hover2,
        day: 'September 22, 2025',
        link: 'https://thelushminds.com/event-details/z_arunachal',
        buttonText: 'Know More',
    },
    {
        li1: 'Creative Retreats',
        li2: 'Pause, reflect and ideate freely',
        li3: 'Tropical Dialogues',
        li4: 'Fireside stories that spark thought',
        li5: 'Beach Escapes',
        li6: 'Explore, unwind and feel inspired',
        title: 'The Oceanic Escape',
        price: 'Z_Goa',
        shape: lv1,
        shape2: lv2,
        hoverBg: hover3,
        day: 'January 10, 2026',
        link: 'https://zentara-himachal.paperform.co',
        buttonText: 'Stay Tuned',
        highlightOrange: true,
    },
];

const Pricing = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className="price-one">
            <div
                className="price-one_pattern"
                style={{ backgroundImage: `url(${bg})` }}
            ></div>
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Where will you connect next?</div>
                    <h2 className="sec-title_heading">Choose Your Next Chapter</h2>
                </div>
                <div className="row clearfix">
                    {pricing.map((pricing, ptem) => (
                        <div className="price-block_one col-lg-4 col-md-6 col-sm-12" key={ptem}>
                            <div
                                className={`price-block_one-inner hover-card ${pricing.highlightOrange ? 'orange-highlight' : ''} ${pricing.greenPrice ? 'green-price' : ''} ${pricing.greenButton ? 'green-button' : ''}`}
                                style={{
                                    '--hover-bg': `url(${pricing.hoverBg})`,
                                }}
                            >
                                {/* <div
                                    className="price-block_one-pattern"
                                    style={{ backgroundImage: `url(${pricing.shape})` }}
                                ></div> */}
                                {/* <div
                                    className="price-block_one-pattern-two"
                                    style={{ backgroundImage: `url(${pricing.shape2})` }}
                                ></div> */}
                                <div className="price-block_one-title">{pricing.title}</div>
                                <div className="price-block_one-price">
                                    {pricing.price}
                                    <br />
                                    <span>{pricing.day}</span>
                                </div>
                                <ul className="price-block_one-options">
                                    <li>
                                        <strong>{pricing.li1}</strong>
                                        {pricing.li2}
                                    </li>
                                    <li className="light">
                                        <strong>{pricing.li3}</strong>
                                        {pricing.li4}
                                    </li>
                                    <li className="light">
                                        <strong>{pricing.li5}</strong>
                                        {pricing.li6}
                                    </li>
                                </ul>
                                <div className="price-block_one-button">
                                    <Link
                                        onClick={ClickHandler}
                                        to={pricing.link}
                                        target="_blank"
                                        className="theme-btn btn-style-two"
                                    >
                                        <span className="btn-wrap">
                                            <span className="text-one">{pricing.buttonText}</span>
                                            <span className="text-two">{pricing.buttonText}</span>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Hover effect styles */}
            <style>{`
    .hover-card {
        position: relative;
        overflow: hidden;
        transition: all 0.4s ease;
        transform: translateY(0);
        background-color: #fff;
        background-size: cover;
        background-position: center;
    }

    .hover-card::before {
        content: "";
        position: absolute;
        inset: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        transition: opacity 0.5s ease;
        z-index: 0;
    }

    .hover-card:hover::before {
        opacity: 1;
        background-image: var(--hover-bg);
    }

    .hover-card:hover {
        transform: translateY(-10px) scale(1.03);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
    }

    .hover-card > * {
        position: relative;
        z-index: 1;
        transition: color 0.3s ease;
    }

    /* ✅ All text white on hover */
    .hover-card:hover .price-block_one-title,
    .hover-card:hover .price-block_one-price,
    .hover-card:hover .price-block_one-price span,
    .hover-card:hover .price-block_one-options li,
    .hover-card:hover .price-block_one-options li strong,
    .hover-card:hover .theme-btn .text-one,
    .hover-card:hover .theme-btn .text-two {
        color: #fff !important;
    }

    /* ✅ Button outline & hover state */
    .hover-card:hover .theme-btn {
        border-color: #fff !important;
        background: transparent !important;
    }

    /* Optional: make sure the inner text contrasts nicely */
    .hover-card .price-block_one-title,
    .hover-card .price-block_one-price,
    .hover-card .price-block_one-options li {
        transition: color 0.3s ease;
    }

    /* Orange highlight styles */
    .orange-highlight .price-block_one-price {
        color: #ff9500 !important;
    }

    .orange-highlight .theme-btn {
        background-color: #ff9500 !important;
        border-color: #ff9500 !important;
    }

    .orange-highlight .theme-btn .text-one,
    .orange-highlight .theme-btn .text-two {
        color: #fff !important;
    }

    .orange-highlight:hover .theme-btn {
        background-color: #ff9500 !important;
        border-color: #ff9500 !important;
    }
        /* Green price styling */
.green-price .price-block_one-price {
    color: #22c55e !important;
}

/* Green button styling */
.green-button .theme-btn {
    background-color: #22c55e !important;
    border-color: #22c55e !important;
}

.green-button .theme-btn .text-one,
.green-button .theme-btn .text-two {
    color: #fff !important;
}

.green-button:hover .theme-btn {
    background-color: #22c55e !important;
    border-color: #22c55e !important;
}
`}</style>

        </section>
    );
};

export default Pricing;
